export function verticalStacker(gap?: string) {
  return {
    display: "flex",
    flexDirection: "column",
    ...(gap && { gap }),
  };
}
export function stacker(gap?: string) {
  return {
    display: "flex",
    ...(gap && { gap }),
  };
}

export function flexEnd() {
  return {
    display: "flex",
    justifyContent: "flex-end",
  };
}
